import React from 'react';
import moment from 'moment';
import { is, prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import LoadField from 'components/common/fields/LoadField';
import { currency as currencyConst } from 'constants/dictionaries';
import { DATE_FORMATS } from 'constants/dateFormats';
import { getPerson } from 'actions/asyncActions';

const PersonFullName = ({ getPerson: { data } }) => (
    <span>{`${data.firstName} ${data.middleName} ${data.lastName}`}</span>
);

const PersonTemplate = withAsyncActions(({ id }) => ({
    getPerson: getPerson
        .withParams(() => 'xml')
        .withPayload(() => id)
        .withOptions({ dispatchOnMount: id !== 0, autoReset: true })
}))(PersonFullName);

const dateMonthYear = (value) => moment(value, DATE_FORMATS.monthYearParse).format(DATE_FORMATS.monthYearFormat);
const date = (value) => moment(value, DATE_FORMATS.parse).format(DATE_FORMATS.format);
const townName = (value) => is(Number, value) ? null : value;
const currency = (fieldId) => <LoadField loadName={currencyConst} fieldName='code' fieldId={Number(fieldId)} />;
const person = (id) => <PersonTemplate id={id} />;

const fieldFilters = {
    'xml.PplInterv.IntDate': date,
    'xml.PplPhoneInterv.INTDATE': date,
    'xml.PplPhoneInterv.createdate': date,
    'xml.PplVerRek.VERREKDATE': date,
    'xml.OrgMrktCall.DATE': date,
    'xml.PplZakInterv.INTDATE': date,
    'xml.MrktCall.DATE': date,
    'xml.MrktCall.NEXTDATE': date,
    'xml.IntRecrRequest.town': townName,
    'xml.IntRecrRequest.otvkey': person,
    'xml.IntRecrRequest.request_date': date,
    'xml.IntRecrRequest.datefrom': date,
    'xml.IntRecrRequest.deadline': date,
    'xml.PplCV.bithday': date,
    'xml.PplCV.begwork': dateMonthYear,
    'xml.PplCV.endwork': dateMonthYear,
    'xml.PplCV.createdate': date,
    'xml.PplCV.sekrdate': date,
    'xml.ZakazComment.DATE': date,
    'xml.IntRecrRequest.salaryvaluta_code': currency,
    'xml.IntRecrRequest.gonorar_type_valuta_code': currency,
    'xml.PplAnketa.birth-date': date,
    'xml.PplAnketa.sekrdate': date,
    'xml.PplAnketa.createdate': date,
    'xml.PplAnketa.begin-date': dateMonthYear,
    'xml.PplAnketa.end-date': dateMonthYear,
    'xml.PrjSomeForm.createdate': date,
    'xml.PrjSomeForm.sekrdate': date,
    'xml.OrgSomeForm.createdate': date,
    'xml.OrgSomeForm.sekrdate': date,
};

export const DocumentFieldText = ({ name, value }) => (
    <span className="pre-wrap">
        { prop(name, fieldFilters) ? fieldFilters[name](value) : value }
    </span>
);
